import React from 'react'
import EntityList from '../Profile/SectionEntityList'
import Contacts from '../Profile/SectionContacts'
import ProjectList from '../Profile/ProjectList'
import Readiness from '../Profile/SectionReadiness'

const CustomModule = props => {
    const { contributor, signalReady } = props

    switch (props.module) {
        case 'e':
            return <EntityList ContributorID={contributor.ContributorID} signalReady={signalReady} />
        case 'c':
            return <Contacts ContributorID={contributor.ContributorID} signalReady={signalReady} />
        case 'fa':
            return <ProjectList ContributorID={contributor.ContributorID} stage="Approved" Total={true} Title='Funded Activities' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} signalReady={signalReady} />
        case 'pp':
            return <ProjectList ContributorID={contributor.ContributorID} stage="Pipeline" Total={true} Title='Pipeline Projects' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} signalReady={signalReady} />
        case 'r':
            return <Readiness contributor={contributor} signalReady={signalReady} />
        default:
            return <div>&nbsp;</div>
    }
}

export default CustomModule